import { Link } from "react-router-dom";
import PageChrome from "@/layouts/PageChrome.jsx";

/*
 * TEMPORARY — Phase 0b.
 *
 * Stands in for a page that has not been built yet, so the whole route tree and
 * the shell can be clicked through before any page work starts. Each real page
 * replaces its entry in App.jsx; this file is deleted once the last one lands.
 *
 * It links to the corresponding markup file so the design being ported is one
 * click away while working.
 */
export default function Placeholder({ title, breadcrumb, markup, phase, notes = [] }) {
    return (
        <main className="mx-auto flex w-full max-w-[1680px] flex-col gap-5 p-4 lg:p-5">
            <PageChrome breadcrumb={breadcrumb ?? [title]} />

            <div className="flex flex-wrap items-start justify-between gap-4">
                <div>
                    <h1 className="text-[22px] font-semibold tracking-tight">{title}</h1>
                    <p className="mt-0.5 text-[13px] text-slate-500 dark:text-slate-400">
                        Not built yet — scheduled for {phase}.
                    </p>
                </div>
                <span className="tag bg-amber-50 text-amber-700 dark:bg-amber-950/60 dark:text-amber-400">
                    Placeholder
                </span>
            </div>

            <section className="card">
                <div className="card-head">
                    <h2 className="card-title">What lands here</h2>
                    <div className="card-extra">
                        <span className="text-xs text-slate-400 dark:text-slate-500">{phase}</span>
                    </div>
                </div>
                <div className="card-body space-y-4">
                    <p className="text-[13.5px] leading-relaxed text-slate-600 dark:text-slate-300">
                        The design for this page is already built and reviewed in the static markup.
                        Porting it means turning that page&apos;s script into components — no design
                        decisions left to make.
                    </p>

                    {notes.length > 0 && (
                        <ul className="space-y-2">
                            {notes.map((note) => (
                                <li
                                    key={note}
                                    className="flex gap-2.5 text-[13px] leading-relaxed text-slate-600 dark:text-slate-300"
                                >
                                    <span className="mt-1.5 size-1.5 shrink-0 rounded-full bg-brand-500" />
                                    <span>{note}</span>
                                </li>
                            ))}
                        </ul>
                    )}

                    {markup && (
                        <div className="flex flex-wrap items-center gap-2.5 border-t border-slate-100 pt-4 dark:border-slate-800">
                            <span className="text-[11px] font-semibold tracking-wider text-slate-400 uppercase dark:text-slate-500">
                                Design source
                            </span>
                            <code className="rounded bg-slate-100 px-1.5 py-0.5 font-mono text-[11.5px] dark:bg-slate-800">
                                html-markup/{markup}
                            </code>
                        </div>
                    )}
                </div>
            </section>

            <p className="text-center text-xs text-slate-400 dark:text-slate-600">
                <Link to="/dashboard" className="hover:underline">
                    Back to dashboard
                </Link>
            </p>
        </main>
    );
}
